import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styles from "./ParameterSettings.local.scss";
import _ from "i18n";
import { setAuthorizationParameters } from "Actions";
import { Collapse, Radio, Switch, Checkbox } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";

class AuthorizationsParameters extends Component {
  constructor(props) {
    super(props);
    let parameterSettings = this.props.data.defaultAuthParameters;
    this.state = {
      authParameters: {
        superadmin: parameterSettings.superadmin,
        admin: parameterSettings.admin,
        partner: parameterSettings.partner,
        collaborator: parameterSettings.collaborator,
        supervisor: parameterSettings.supervisor,
        none: parameterSettings.none
      },
      activeTab: "SUPERADMIN"
    };
  }

  categories = [
    {
      id: "SUPERADMIN",
      label: _("SUPERADMIN")
    },
    {
      id: "ADMIN",
      label: _("ADMIN")
    },
    {
      id: "PARTNER",
      label: _("partner")
    },
    {
      id: "COLLABORATOR",
      label: _("COLLABORATOR")
    },
    {
      id: "SUPERVISOR",
      label: _("SUPERVISOR")
    },
    {
      id: "NONE",
      label: _("NONE")
    }
  ];

  handleTabChange = activeTab => {
    this.setState(prevState => ({
      ...prevState,
      activeTab
    }));
  };

  handleToggle = value => {
    this.setState(prevState => ({
      ...prevState,
      expanded: value
    }));
  };

  handleParameterChange = (role, path, value) => {
    const { dispatch, handleDisabledSave } = this.props;
    handleDisabledSave(false);

    this.setState(prevState => {
      const keys = path.split(".");

      const updateNestedState = (obj, keys, value) => {
        if (keys.length === 1) {
          return { ...obj, [keys[0]]: value };
        }

        const [firstKey, ...restKeys] = keys;
        return {
          ...obj,
          [firstKey]: updateNestedState(obj[firstKey] || {}, restKeys, value)
        };
      };

      return {
        ...prevState,
        authParameters: {
          ...prevState.authParameters,
          [role]: updateNestedState(
            prevState.authParameters[role] || {},
            keys,
            value
          )
        }
      };
    });

    dispatch(setAuthorizationParameters(role, path, value));
  };

  renderViewDataBySwitch(role, title, path, allowViewData) {
    return (
      <div>
        <div className={"switch"}>
          <span className="sidebar_role">{_(title)}</span>
        </div>
        <Radio.Group
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 15,
            marginLeft: 80
          }}
          onChange={event =>
            this.handleParameterChange(role, path, event.target.value)
          }
          value={allowViewData}
          options={[
            {
              value: 0,
              label: _("noAccess")
            },
            {
              value: 1,
              label: _("all")
            },
            {
              value: 10,
              label: _("personal")
            },
            {
              value: 11,
              label: _("partnership")
            },
            {
              value: 100,
              label: _("BU")
            },
            {
              value: 101,
              label: _("zone")
            },
            {
              value: 110,
              label: _("backup")
            }
          ]}
        />
      </div>
    );
  }

  renderViewDataByRadio(role, title, path, viewData) {
    return (
      <div>
        <div className={"switch sub_switch"}>
          <span className="sidebar_role">{_("for")}</span>
        </div>
        <Checkbox.Group
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 15,
            marginLeft: 80
          }}
          onChange={event => {
            if (event.includes(1) && !viewData.allowViewDataFor.includes(1)) {
              this.handleParameterChange(role, path + ".allowViewDataFor", [1]);
            } else if (
              event.length > 1 &&
              viewData.allowViewDataFor.length === 1 &&
              viewData.allowViewDataFor.includes(1)
            ) {
              let data = event.filter(item => item > 1);
              this.handleParameterChange(
                role,
                path + ".allowViewDataFor",
                data
              );
            } else if (event.length === 0) {
              this.handleParameterChange(
                role,
                path + ".allowViewDataFor",
                viewData.allowViewDataFor
              );
            } else {
              this.handleParameterChange(
                role,
                path + ".allowViewDataFor",
                event
              );
            }
          }}
          value={viewData.allowViewDataFor}
          options={[
            {
              value: 1,
              label: _("all")
            },
            {
              value: 10,
              label: _("personal")
            },
            {
              value: 11,
              label: _("partnership")
            },
            {
              value: 100,
              label: _("BU")
            },
            {
              value: 101,
              label: _("zone")
            },
            {
              value: 110,
              label: _("backup")
            }
          ]}
        />
        <div className={"switch sub_switch"}>
          <span className="sidebar_role">{_("by")}</span>
        </div>
        <Checkbox.Group
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 15,
            marginLeft: 80
          }}
          onChange={event => {
            if (event.length === 0) {
              this.handleParameterChange(
                role,
                path + ".allowViewDataBy",
                viewData.allowViewDataBy
              );
            } else {
              this.handleParameterChange(
                role,
                path + ".allowViewDataBy",
                event
              );
            }
          }}
          value={viewData.allowViewDataBy}
          options={[
            {
              value: 1,
              label: _("appWeb")
            },
            {
              value: 2,
              label: _("Mail")
            },
            {
              value: 3,
              label: _("appMobile")
            }
          ]}
        />
      </div>
    );
  }

  toogleViewDataByRadio(role, path, val) {
    this.handleParameterChange(
      role,
      path + ".allowViewDataFor",
      val ? [10] : []
    );
    this.handleParameterChange(role, path + ".allowAccess", val);
    this.handleParameterChange(role, path + ".allowViewDataBy", val ? [1] : []);
  }

  renderSettings(role, authSetting) {
    const {
      dashboard,
      clients,
      collaborators,
      prestations,
      notifications,
      financial,
      reporting,
      capacityPlanning,
      settings,
      timesheet
    } = authSetting;
    return (
      <Fragment>
        <Collapse defaultActiveKey={["1"]}>
          <CollapsePanel header={_("notificationPrivileges")} key="1">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowFonctionnality")}</span>
              <Switch
                checked={notifications.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "notifications.allowAccess",
                    val
                  )
                }
              />
            </div>
            {notifications.allowAccess && (
              <Collapse
                defaultActiveKey={["11"]}
                style={{
                  width: "82%",
                  marginLeft: "9%",
                  backgroundColor: "transparent"
                }}
              >
                <CollapsePanel header="Notification Supervision" key="11">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationSupervision")}
                    </span>
                    <Switch
                      checked={notifications.supervision.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.supervision",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.supervision.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.supervision",
                      notifications.supervision
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("validationNotifSupervision")}
                    </span>
                    <Switch
                      checked={
                        notifications.validationRequestSupervision.allowAccess
                      }
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.validationRequestSupervision",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.validationRequestSupervision.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.validationRequestSupervision",
                      notifications.validationRequestSupervision
                    )}
                </CollapsePanel>
                <CollapsePanel
                  header="Notification Rapport de Supervision"
                  key="12"
                >
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationSupervisionRepport")}
                    </span>
                    <Switch
                      checked={notifications.supervisionRepport.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.supervisionRepport",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.supervisionRepport.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.supervisionRepport",
                      notifications.supervisionRepport
                    )}
                </CollapsePanel>
                <CollapsePanel header="Notification Calendar" key="13">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationCalendarAttachmentRequest")}
                    </span>
                    <Switch
                      checked={notifications.attachmentRequest.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.attachmentRequest",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.attachmentRequest.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.attachmentRequest",
                      notifications.attachmentRequest
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationCalendarAbsenceRequest")}
                    </span>
                    <Switch
                      checked={notifications.absenceRequest.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.absenceRequest",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.absenceRequest.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.absenceRequest",
                      notifications.absenceRequest
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationCalendarAbsenceStatus")}
                    </span>
                    <Switch
                      checked={notifications.absenceStatus.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.absenceStatus",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.absenceStatus.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.absenceStatus",
                      notifications.absenceStatus
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationCalendarAbsenceAssignment")}
                    </span>
                    <Switch
                      checked={notifications.absenceAssignment.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.absenceAssignment",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.absenceAssignment.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.absenceAssignment",
                      notifications.absenceAssignment
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationCalendarAbsenceBackup")}
                    </span>
                    <Switch
                      checked={notifications.absenceBackup.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.absenceBackup",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.absenceBackup.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.absenceBackup",
                      notifications.absenceBackup
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationCalendarSickLeave")}
                    </span>
                    <Switch
                      checked={notifications.sickLeave.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.sickLeave",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.sickLeave.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.sickLeave",
                      notifications.sickLeave
                    )}
                </CollapsePanel>
                <CollapsePanel header="Notification Time-Sheet" key="14">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationTSReminder")}
                    </span>
                    <Switch
                      checked={notifications.tsReminder.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.tsReminder",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.tsReminder.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.tsReminder",
                      notifications.tsReminder
                    )}
                </CollapsePanel>
                <CollapsePanel header="Notification Forfait" key="15">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationForfait")}
                    </span>
                    <Switch
                      checked={notifications.forfait.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.forfait",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.forfait.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.forfait",
                      notifications.forfait
                    )}
                </CollapsePanel>
                <CollapsePanel header="Notification Croissance" key="16">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationclientToAttribut")}
                    </span>
                    <Switch
                      checked={notifications.clientToAttribut.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.clientToAttribut",
                          val
                        )
                      }
                    />
                  </div>
                  {/* {notifications.clientToAttribut.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.clientToAttribut",
                      notifications.clientToAttribut
                    )} */}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationBudgetIncomplet")}
                    </span>
                    <Switch
                      checked={notifications.budgetIncomplet.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.budgetIncomplet",
                          val
                        )
                      }
                    />
                  </div>
                  {/* {notifications.budgetIncomplet.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.budgetIncomplet",
                      notifications.budgetIncomplet
                    )} */}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationNewClient")}
                    </span>
                    <Switch
                      checked={notifications.newClient.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.newClient",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.newClient.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.newClient",
                      notifications.newClient
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationClientRisk")}
                    </span>
                    <Switch
                      checked={notifications.clientRisk.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.clientRisk",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.clientRisk.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.clientRisk",
                      notifications.clientRisk
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationClientRecovered")}
                    </span>
                    <Switch
                      checked={notifications.clientRecovered.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.clientRecovered",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.clientRecovered.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.clientRecovered",
                      notifications.clientRecovered
                    )}
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("notificationClientDepart")}
                    </span>
                    <Switch
                      checked={notifications.clientDepart.allowAccess}
                      onChange={val =>
                        this.toogleViewDataByRadio(
                          role,
                          "notifications.clientDepart",
                          val
                        )
                      }
                    />
                  </div>
                  {notifications.clientDepart.allowAccess &&
                    this.renderViewDataByRadio(
                      role,
                      "viewDataBy",
                      "notifications.clientDepart",
                      notifications.clientDepart
                    )}
                </CollapsePanel>
              </Collapse>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("dashboardPrivileges")} key="2">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={dashboard.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "dashboard.allowAccess", val)
                }
              />
            </div>
          </CollapsePanel>
          <CollapsePanel header={_("clientsPrivileges")} key="3">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={clients.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "clients.allowAccess", val)
                }
              />
            </div>
            {clients.allowAccess && (
              <Fragment>
                {this.renderViewDataBySwitch(
                  role,
                  "viewPortfolioDataBy",
                  "clients.allowViewDataBy",
                  clients.allowViewDataBy
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowConfigurateBudget")}
                  </span>
                  <Switch
                    checked={clients.allowUpdateBudgetConfig}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "clients.allowUpdateBudgetConfig",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdateClientSettings")}
                  </span>
                  <Switch
                    checked={clients.allowUpdateClientSettings}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "clients.allowUpdateClientSettings",
                        val
                      )
                    }
                  />
                </div>
              </Fragment>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("collaboratorsPrivileges")} key="4">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={collaborators.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "collaborators.allowAccess",
                    val
                  )
                }
              />
            </div>
            {collaborators.allowAccess && (
              <Fragment>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowConfigCollaborator")}
                  </span>
                  <Switch
                    checked={collaborators.allowConfigCollaborator}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowConfigCollaborator",
                        val
                      )
                    }
                  />
                </div>
                {this.renderViewDataBySwitch(
                  role,
                  "viewDataBy",
                  "collaborators.allowViewDataBy",
                  collaborators.allowViewDataBy
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowCoefficientsConfig")}
                  </span>
                  <Switch
                    checked={collaborators.allowCoefficientsConfig}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowCoefficientsConfig",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessProdCapacity")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessCPr}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessCPr",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessPlans")}</span>
                  <Switch
                    checked={collaborators.allowAccessPlans}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessPlans",
                        val
                      )
                    }
                  />
                </div>
                {collaborators.allowAccessPlans && (
                  <Fragment>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromToDo")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromToDo}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromToDo",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromWIP")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromWIP}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromWIP",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromValidate")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromValidate}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromValidate",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromDone")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromDone}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromDone",
                            val
                          )
                        }
                      />
                    </div>
                  </Fragment>
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCalendar")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessCalendar}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessCalendar",
                        val
                      )
                    }
                  />
                </div>
                {collaborators.allowAccessCalendar && (
                  <div className={"switch sub_tab"}>
                    <span className="sidebar_role">
                      {_("allowValidateVacationRequest")}
                    </span>
                    <Switch
                      checked={collaborators.allowValidateVacationRequest}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "collaborators.allowValidateVacationRequest",
                          val
                        )
                      }
                    />
                  </div>
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPlanification")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessPlanification}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessPlanification",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFolderCapacity")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessFolderCapacity}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessFolderCapacity",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFinancialState")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessFinancialState}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessFinancialState",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAddBinomEvent")}
                  </span>
                  <Switch
                    checked={collaborators.allowAddBinomEvent}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAddBinomEvent",
                        val
                      )
                    }
                  />
                </div>
              </Fragment>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("financialPrivileges")} key="5">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={financial.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "financial.allowAccess", val)
                }
              />
            </div>
            {financial.allowAccess && (
              <Collapse
                defaultActiveKey={["51"]}
                style={{
                  width: "82%",
                  marginLeft: "9%",
                  backgroundColor: "transparent"
                }}
              >
                <CollapsePanel header="Table Dynamique" key="51">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessDynamicTab")}
                    </span>
                    <Switch
                      checked={financial.dynamicTable.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.dynamicTable.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.dynamicTable.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "financial.dynamicTable.allowViewDataBy",
                      financial.dynamicTable.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Financial Sheet" key="52">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessFinancial")}
                    </span>
                    <Switch
                      checked={financial.financialState.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.financialState.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.financialState.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "financial.financialState.allowViewDataBy",
                      financial.financialState.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Forfait" key="53">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessForfait")}
                    </span>
                    <Switch
                      name="allowAccessForfait"
                      checked={financial.forfait.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.forfait.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.forfait.allowAccess && (
                    <div className={"switch"}>
                      <span className="sidebar_role">
                        {_("allowAccessRevision")}
                      </span>
                      <Switch
                        checked={financial.forfait.allowLaunchRevision}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "financial.forfait.allowLaunchRevision",
                            val
                          )
                        }
                      />
                    </div>
                  )}
                </CollapsePanel>
                <CollapsePanel header="Croissance" key="54">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessCroissance")}
                    </span>
                    <Switch
                      checked={financial.croissance.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.croissance.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.croissance.allowAccess && (
                    <Fragment>
                      {this.renderViewDataBySwitch(
                        role,
                        "viewDataBy",
                        "financial.croissance.allowViewDataBy",
                        financial.croissance.allowViewDataBy
                      )}
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessClientIn")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessIN}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessIN",
                              val
                            )
                          }
                        />
                      </div>
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessClientOut")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessOUT}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessOUT",
                              val
                            )
                          }
                        />
                      </div>
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessClientsToMonitor")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessToMonitor}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessToMonitor",
                              val
                            )
                          }
                        />
                      </div>
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessLeaving")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessLeaving}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessLeaving",
                              val
                            )
                          }
                        />
                      </div>
                    </Fragment>
                  )}
                </CollapsePanel>
              </Collapse>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("prestationsPrivileges")} key="6">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={prestations.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "prestations.allowAccess",
                    val
                  )
                }
              />
            </div>
            {prestations.allowAccess &&
              this.renderViewDataBySwitch(
                role,
                "viewDataBy",
                "prestations.allowViewDataBy",
                prestations.allowViewDataBy
              )}
          </CollapsePanel>
          <CollapsePanel header={_("reportingPrivileges")} key="7">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={reporting.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "reporting.allowAccess", val)
                }
              />
            </div>
            {reporting.allowAccess && (
              <Collapse
                defaultActiveKey={["1x"]}
                style={{
                  width: "82%",
                  marginLeft: "9%",
                  backgroundColor: "transparent"
                }}
              >
                <CollapsePanel header="Suivi de Production" key="1x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessProdCapacity")}
                    </span>
                    <Switch
                      name="allowAccessProdCapacity"
                      checked={reporting.production.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.production.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.production.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.production.allowViewDataBy",
                      reporting.production.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Développement Individuel BE" key="2x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessIndivDevBe")}
                    </span>
                    <Switch
                      name="allowAccessIndivDevBe"
                      checked={reporting.individualDevBe.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.individualDevBe.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.individualDevBe.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.individualDevBe.allowViewDataBy",
                      reporting.individualDevBe.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Développement Individuel MA" key="3x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessIndivDevMa")}
                    </span>
                    <Switch
                      checked={reporting.individualDevMa.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.individualDevMa.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.individualDevMa.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.individualDevMa.allowViewDataBy",
                      reporting.individualDevMa.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi d'Echéances" key="4x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessEcheance")}
                    </span>
                    <Switch
                      checked={reporting.echeance.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.echeance.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.echeance.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.echeance.allowViewDataBy",
                      reporting.echeance.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Récapitulatif Bilans" key="5x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessBalanceRecap")}
                    </span>
                    <Switch
                      checked={reporting.recapBalance.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.recapBalance.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.recapBalance.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.recapBalance.allowViewDataBy",
                      reporting.recapBalance.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Calendrier" key="6x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessCalendar")}
                    </span>
                    <Switch
                      checked={reporting.calendar.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.calendar.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.calendar.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.calendar.allowViewDataBy",
                      reporting.calendar.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi de Temps" key="7x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessTimeReport")}
                    </span>
                    <Switch
                      checked={reporting.timesheet.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.timesheet.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.timesheet.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.timesheet.allowViewDataBy",
                      reporting.timesheet.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi des Portefeuilles" key="8x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessPortfolio")}
                    </span>
                    <Switch
                      checked={reporting.portfolio.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.portfolio.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.portfolio.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.portfolio.allowViewDataBy",
                      reporting.portfolio.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Supervision" key="9x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessErrReporting")}
                    </span>
                    <Switch
                      checked={reporting.supervision.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.supervision.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.supervision.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.supervision.allowViewDataBy",
                      reporting.supervision.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Matrice de Congé" key="10x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessVacationMatrix")}
                    </span>
                    <Switch
                      checked={reporting.vacation.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.vacation.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.vacation.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.vacation.allowViewDataBy",
                      reporting.vacation.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Gestion des Plans" key="11x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessPlans")}
                    </span>
                    <Switch
                      checked={reporting.plans.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.plans.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.plans.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.plans.allowViewDataBy",
                      reporting.plans.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi des Prestations" key="12x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessPrestation")}
                    </span>
                    <Switch
                      checked={reporting.prestations.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.prestations.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.prestations.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.prestations.allowViewDataBy",
                      reporting.prestations.allowViewDataBy
                    )}
                </CollapsePanel>
              </Collapse>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("cpPrivileges")} key="8">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={capacityPlanning.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "capacityPlanning.allowAccess",
                    val
                  )
                }
              />
            </div>
            {capacityPlanning.allowAccess &&
              this.renderViewDataBySwitch(
                role,
                "viewDataBy",
                "capacityPlanning.allowViewDataBy",
                capacityPlanning.allowViewDataBy
              )}
          </CollapsePanel>
          <CollapsePanel header={_("settingPrivileges")} key="9">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={settings.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "settings.allowAccess", val)
                }
              />
            </div>
            {settings.allowAccess && (
              <Fragment>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCategories")}
                  </span>
                  <Switch
                    checked={settings.allowAccessCategories}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessCategories",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessTaskTypes")}
                  </span>
                  <Switch
                    checked={settings.allowAccessTaskTypes}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessTaskTypes",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCollaborators")}
                  </span>
                  <Switch
                    checked={settings.allowAccessCollaborators}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessCollaborators",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCalendarSet")}
                  </span>
                  <Switch
                    checked={settings.allowAccessCalendar}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessCalendar",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessParameters")}
                  </span>
                  <Switch
                    checked={settings.allowAccessParameters}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessParameters",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessUsers")}</span>
                  <Switch
                    checked={settings.allowAccessUsers}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessUsers",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessSynchronization")}
                  </span>
                  <Switch
                    checked={settings.allowAccessSynchronization}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessSynchronization",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessModels")}</span>
                  <Switch
                    checked={settings.allowAccessModels}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessModels",
                        val
                      )
                    }
                  />
                </div>
              </Fragment>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("timesheetPrivileges")} key="10">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={timesheet.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "timesheet.allowAccess", val)
                }
              />
            </div>
            {timesheet.allowAccess &&
              this.renderViewDataBySwitch(
                role,
                "viewDataBy",
                "timesheet.allowViewDataBy",
                timesheet.allowViewDataBy
              )}
          </CollapsePanel>
        </Collapse>
      </Fragment>
    );
  }

  renderAuthorizationParameters() {
    const { authParameters } = this.state;
    switch (this.state.activeTab) {
      case "SUPERADMIN":
        return this.renderSettings("superadmin", authParameters.superadmin);
      case "ADMIN":
        return this.renderSettings("admin", authParameters.admin);
      case "PARTNER":
        return this.renderSettings("partner", authParameters.partner);
      case "COLLABORATOR":
        return this.renderSettings("collaborator", authParameters.collaborator);
      case "SUPERVISOR":
        return this.renderSettings("supervisor", authParameters.supervisor);
      case "NONE":
        return this.renderSettings("none", authParameters.none);
      default:
        return null;
    }
  }

  render() {
    const { activeTab } = this.state;
    return (
      <div>
        <div
          className={styles.tab_synchronization}
          style={{ height: "fit-content" }}
        >
          <div className={styles.header}>
            <span>{_("parameterAuth")}</span>
          </div>
          <div
            className={styles.body}
            style={{
              height: "fit-content",
              width: "100%",
              margin: 0,
              boxShadow: "none",
              border: 0
            }}
          >
            <div className={styles.filter_tab}>
              {this.categories.map(category => {
                return (
                  <span
                    className={`${activeTab === category.id &&
                      styles.active_tab}`}
                    onClick={() =>
                      this.setState({
                        activeTab: category.id
                      })
                    }
                  >
                    {category.label}
                  </span>
                );
              })}
            </div>
            <div style={{ padding: "10px 20px" }}>
              {this.renderAuthorizationParameters()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  parameterSettings: state.parameterSettings
});

export default connect(mapStateToProps)(AuthorizationsParameters);



// WEBPACK FOOTER //
// ./src/components/ParameterSettings/AuthorizationsParamaters.js